import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/shared/user-login/login.service';
import { TicketService } from '../shared/customer/ticket/ticket.service';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
    selector: 'app-raise-ticket',
    templateUrl: './raise-ticket.component.html',
    styleUrls: ['./raise-ticket.component.css'],
    standalone: false
})
export class RaiseTicketComponent implements OnInit {
  serverErrorMessages: string;
  successMessage: string;
  role: string = 'NO_ROLE'
  issue;
  loading: boolean = true
  constructor(public loginService: LoginService,private ticketService: TicketService,private SpinnerService: NgxSpinnerService, private router : Router) {}

  ngOnInit(): void {
    // this.SpinnerService.show();
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.loading = false;
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.loading = false;
        }
      )
    }
    else{
      this.loading = false;
      this.router.navigateByUrl('/signin');
    }
    // this.SpinnerService.hide();
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  onSubmit(form){
   //console.log('form value', form.value)
    this.ticketService.raiseTicket({message: form.value.issue},null).subscribe(
      res => {
       //console.log('Ticket Generated', res);
        alert("Ticket raised successfully! We will reach out to you soon. Thank you for the patience.");
        alert("Responses will be done from 08:30 AM to 05:00 PM on working days");
        this.router.navigateByUrl('/home');
      },
      err => {
       //console.log('Error generating ticket contact admin', err);
       console.log('Error generating ticket contact admin beta', err);
        this.serverErrorMessages = err.error.message
      }
    )
  }

  onLogout(){
    this.loginService.deleteToken();
    this.router.navigateByUrl('/signin');
  }

}
